export default __webpack_public_path__ + "slices/main/assets/public/podcast-subscribe-toggle/rss.76688f351107e1836a48b223763d184b.svg";